// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__103ut","logo":"styles_logo__2I-b3","spacer":"styles_spacer__3LkrW","navLink":"styles_navLink__ei7tB","dropdownLink":"styles_dropdownLink__30oFw"};